import { jsx } from "react/jsx-runtime";
import { TextArea, TextAreaTheme } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useRef, useCallback } from "react";
import { useForcedState, ForcedState } from "../../contexts/forced-state-context.js";
import { classes } from "../../ui/text-area-field/text-area-field-wut.st.css";
const TextAreaInputWUT = ({
  label,
  placeholder,
  required,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled = false,
  readOnly = false,
  inputId,
  hasError,
  ariaDescribedBy
}) => {
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const textAreaRef = useRef(null);
  const handleChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      onChange(newValue);
    },
    [onChange]
  );
  return /* @__PURE__ */ jsx(
    TextArea,
    {
      id: inputId,
      error: hasError,
      newErrorMessage: true,
      className: classNames(classes.textArea, classes.theme, {
        [classes.error]: hasError,
        [classes.hover]: forcedHover
      }),
      ariaLabel: label ?? "",
      value: value ? String(value) : "",
      onChange: handleChange,
      onFocus,
      onBlur,
      disabled,
      readOnly,
      placeholder,
      theme: TextAreaTheme.Box,
      "aria-describedby": ariaDescribedBy,
      "aria-invalid": hasError,
      required,
      ref: textAreaRef
    }
  );
};
export {
  TextAreaInputWUT
};
//# sourceMappingURL=text-area-input-wut.js.map
